module.exports = __webpack_public_path__ + "media/Video 116.b5f5b8a3.mp4";